const _ = require('underscore');
const { ajax } = require('../utils');

module.exports = function upload(uploadInfo, data, file, saveOptions = {}) {
  file.attributes.url = uploadInfo.url;
  file._bucket = uploadInfo.bucket;
  file.id = uploadInfo.objectId;


  return ajax({
    url: uploadInfo.upload_url,
    method: 'PUT',
    data,
    headers: _.extend(
      {
        'Content-Type': file.get('mime_type'),
        'Cache-Control': 'public, max-age=31536000',
      },
      file._uploadHeaders
    ),
    onprogress: saveOptions.onprogress,
  }).then(() => file);
};



// WEBPACK FOOTER //
// ./src/uploader/s3.js